import { render, staticRenderFns } from "./AttachDocumentsImageManager.vue?vue&type=template&id=764e6014&scoped=true&"
import script from "./AttachDocumentsImageManager.vue?vue&type=script&lang=js&"
export * from "./AttachDocumentsImageManager.vue?vue&type=script&lang=js&"
import style0 from "./AttachDocumentsImageManager.vue?vue&type=style&index=0&id=764e6014&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764e6014",
  null
  
)

export default component.exports